import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "questionsConfirmTable" }
const _hoisted_2 = { id: "question_code" }
const _hoisted_3 = {
  key: 0,
  class: "attention"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "contents-question-confirm-textarea"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = ["src"]


import { Question } from "@/models/healthCare/types/question";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionTableConfirm',
  props: {
    questions: {}
  },
  setup(__props: any) {


//回答選択内容取得
const getChoiceText = (
  question: { choices?: { choice_code: string; choice_text: string }[] },
  choice_code: string
) => {
  const choice = question.choices?.find((c) => c.choice_code === choice_code);
  return choice ? choice.choice_text : choice_code;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "contents-question-title",
        key: question.question_code
      }, [
        _createElementVNode("th", _hoisted_2, [
          _createTextVNode(_toDisplayString(question.question_text) + " ", 1),
          (question.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "※"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", null, [
          (question.answer_format === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(question.answer), 1))
            : _createCommentVNode("", true),
          (question.answer_format === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(question.answer), 1))
            : _createCommentVNode("", true),
          (question.answer_format === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(getChoiceText(question, question.answer as string)), 1))
            : _createCommentVNode("", true),
          (question.answer_format === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answer, (answer, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(getChoiceText(question, answer)) + " ", 1),
                    (index < question.answer.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, ", "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (question.answer_format === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (question.preview)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: question.preview,
                      alt: "Preview",
                      class: "image-preview"
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})